import { render, staticRenderFns } from "./OrganisationEdit.vue?vue&type=template&id=6b517324&scoped=true&"
import script from "./OrganisationEdit.vue?vue&type=script&lang=js&"
export * from "./OrganisationEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationEdit.vue?vue&type=style&index=0&id=6b517324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b517324",
  null
  
)

export default component.exports